<script setup lang="ts">
let timeout: ReturnType<typeof setTimeout> | null = null;
const router = useRouter();
// import { i18n } from "@/i18n";

onMounted(() => {
  timeout = setTimeout(() => {
    void router.replace("/");
  }, 5000);
});

onUnmounted(() => {
  if (timeout) clearTimeout(timeout);
});
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center gap-3 text-center">
    <span class="text-primary text-3xl font-semibold">{{ $t("app.notFound.title") }}</span>
    <span class="text-text-grey text-lg">{{ $t("app.notFound.text") }}</span>
  </div>
</template>
